module.exports = __webpack_public_path__ + "img/main-bg-2.e8f2b22d.jpg";